import React from "react";
import axios from 'axios';
import { useEffect, useState } from 'react';
import { getNBNApiHeader } from "utlis/commonfunctions";
// import Loader from "../components/loader";


const Modem = ({ getDefaultModem, getShippingCharge ,getGstShippingCharge,userToken}) => {



const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_TOKEN;
const headers = getNBNApiHeader();

const [modem, setModem] = useState([]);
const [needModem, setNeedModem] = useState('no');
const [modemSelection, setModemSelection] = useState(false);
const [dftModemId, setDftModemId] = useState(false);
const [dftModemDetails, setDftModemDetails] = useState(false);

const loadModem = async(value) => {

    if(needModem === 'no' && value === 'yes'){

            const payload={}

            let res  = await axios.post(apiUrl+'nbn/get-nbn-products',payload , {headers:headers}).then(async response => {
                if(response.status === 200){              
                    setModemSelection(response.data.data.products);
                    setNeedModem('yes');
                    var arrayLength = response.data.data.products.length - 1;
                    if(response.data.data.products[arrayLength]){
                        setDftModemId(response.data.data.products[arrayLength].nbn_product_id);
                        getDefaultModem(response.data.data.products[arrayLength]);
                        setDftModemDetails(response.data.data.products[arrayLength]);
                         getShippingCharge(response.data.data.shipping_charge);
                         getGstShippingCharge(response.data.data.gst_inclusive_shipping_charge)
                        // getShippingCharge(response.data.data.gst_inclusive_shipping_charge);
                        
                       
                    }


                }else{
                  
                  setNeedModem('no');
                  
                }
             
            }).catch(error => {   
                         
                setNeedModem('no');

            }); 

    }else if(value==='yes'){

        setNeedModem('yes');
        getDefaultModem(dftModemDetails);

    }else{

        setNeedModem('no');
        getDefaultModem(false);
        getShippingCharge(null);
        getGstShippingCharge(null)
    }

} 



const getDefaultModemHanlder = (modems, modemId) => {
  console.log("modem",modems)
  setDftModemId(modemId);
  getDefaultModem(modems);
}



  return (
   <div className="container">
    <section className="common-section">
        <div className="row">
            <div className="col-md-12"><br />
                <div className="header-title">
                    <h2 className="h3">3.Select Modem</h2>
                    <p style={{ textAlign:'left' }}>The selected modem will be delivered to the customer's address. Please ensure that the address provided is correct for accurate delivery.<br></br> Telsim dispatch team will send the modem to the customer using AU Express Post. AU Express Post delivery timeline applies. </p>
                </div>
                <button className="button-57" role="button" onClick={e=> loadModem('yes')} id={needModem == 'yes' ? 'activeModemview' : 'inactiveModemview'}><span className="text">YES</span><span>YES</span></button>
                <button className="button-57" role="button" onClick={e=> loadModem('no')} id={needModem == 'no' ? 'activeModemview' : 'inactiveModemview'}><span className="text">NO</span><span>NO</span></button><br /><br /><br />
            </div>


            {needModem === 'yes' &&  modemSelection && modemSelection.map((modemDetails,i) =>

                    <div key={i} className="col-md-6">
                      <div className="modem-card">
                        <h3>{modemDetails.nbn_product_name}</h3>
                        <strong style={{color: '#777'}}>
                        <>
                        
                        </>
                        </strong>
                        <hr />
                        <img src={modemDetails.product_image} width="250px" height="auto" />
                        <div className="modem-bg">
                            <h2>{'$'+modemDetails.product_website_sell_amount}<span>/ UPFRONT</span></h2>
                        </div><br />
                        <div className="modem-features">
                        <h6>Features of Modem</h6>
                        <ul>
                        {modemDetails.description && modemDetails.description.map((descriptions,j) =>

                          <li>{descriptions}</li>

                        )}
                        </ul>
                        </div>

                        <button onClick={e=> getDefaultModemHanlder(modemDetails,modemDetails.nbn_product_id)}>

                        {dftModemId === modemDetails.nbn_product_id  ? 
                                <>
                                ✓ SELECTED
                                </>
                                :
                                <>
                                SELECT
                                </>
                              }


                        </button>
                      </div>
                    </div>
            
            )}




        </div>
    </section>
</div>


  );
}

export default Modem;
